import React from "react";

export const ContainerToPrint = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      {props.children}
    </div>
  );
});
